<template>
    <li v-show="show">
        <div :class="{'tree-item':true,selected:selected&&selected.id==model.id}">
            <Icon
                    style="padding: 0 5px;"
                    size="20px"
                    v-if="hasChild"
                    :name="open ? 'arrow-down' : 'arrow'"
                    @click.stop="open=!open"
            />
            <span :class="{'tree-title':true,disabled:model.disabled}">
                <!--<Icon v-if="icon" :name="icon"/>-->
                <span @click="toggle">
                    {{ model.name || model.title }}
                    {{ model.deviceCount  == undefined ? " " : ("(" + model.deviceCount + ")") }}
                </span>
            </span>
            <span class="choose" v-if="hasChild"
                  @click="itemClick(model)"
            >选择</span>
        </div>

        <ul v-show="open" v-if="hasChild">
            <tree-menu :selected="selected"
                       :depth="depth-1"
                       @item="itemClick"
                       v-for="item in model.childrenList"
                       v-bind:model="item"
                       v-bind:searchText="searchText"
                       v-bind:key="item.id"
            ></tree-menu>
        </ul>
    </li>
</template>

<script>
    import {Icon} from "vant";
    import {downloadImg} from "@/config"

    function search(data, text, index = 0, showParent) {
        if (showParent) return data
        return data.filter(item => {
            const title = item.name
            const showSelf = hasData(text, title)
            const showChild = search(item.childrenList || [], text, index + 1, showSelf).length > 0
            return showSelf | showChild
        });
    }

    function hasData(text = '', name = '') {
        return text | (name && name.indexOf(text) >= 0)
    }

    export default {
        name: "TreeMenu",
        props: {
            model:{type: Object, required: true},
            selected:{type: Object, required: false},
            searchText:{type: String, required: true},
            depth:{type: Number, default: 1},

        },
        components: {
            Icon
        },
        data() {
            return {
                downloadImg,
                open: this.depth>0
            };
        },
        computed: {
            hasChild() {
                return this.model.childrenList && this.model.childrenList.length;
            },
            show() {
                return search([this.model], this.searchText).length
            }
        },
        methods: {
            toggle() {
                if (this.hasChild) {
                    this.open = !this.open;
                } else {
                    this.itemClick(this.model)
                }
            },
            itemClick(data) {
                this.$emit("item", data);
            }
        },
    };
</script>

<style lang="less" scoped>
    @import "../style/constant.less";

    ul {
        list-style: none;
        box-sizing: border-box;
        padding-top: 8px;
    }

    li {
        padding: 8px 0px 8px 12px;
        box-sizing: border-box;
        font-size: @item-title-small - 1px;
        font-weight: @item-title-weight-mini;
    }

    .tree-item {
        &.selected {
            background: rgba(24, 144, 255, 0.7);
            border-radius: 3px;
            .choose {
                color: #fff;
            }
        }
        width: 100%;
        box-sizing: border-box;
        padding: 4px 15px 4px 5px;
        display: flex;
        justify-content: left;
        position: relative;
        align-items: center;
        &::after {
            content: "";
            position: absolute;
            bottom: -9px;
            width: 100%;
            height: 1px;
            background-color: #f0eaea;
        }
        .tree-title {
            display: flex;
            width: 100%;
            justify-content: flex-start;
            align-items: center;
            span {
                margin-left: 5px;
            }
        }
        .choose {
            width: 50px;
            display: flex;
            justify-content: flex-end;
            color: #1989fa;
        }
    }
</style>
